import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

export default {
    name: 'reminder',
    state: {
        selectedReminder: null
    },
    getters: {
        getSelectedReminder: state => {
            return state.selectedReminder
        },
    },
    mutations: {
        SET_SELECTED_REMINDER(state, payload) {
            state.selectedReminder = payload
        },
    
        CLEAR_SELECTED_REMINDER(state) {
            state.selectedReminder = null
        }
    },
    actions: {
        setSelectedReminder({ commit }, payload) {
            commit('SET_SELECTED_REMINDER', payload)
        },
    
        clearSelectedReminder({ commit }) {
            commit('CLEAR_SELECTED_REMINDER')
        }
    }
}